import { render, staticRenderFns } from "./WootReports.vue?vue&type=template&id=c5f8a6c6&"
import script from "./WootReports.vue?vue&type=script&lang=js&"
export * from "./WootReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports